// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_SubscriptionSyncInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /subscriptions/admin/subscriptions/{id}/sync (#27)
 *
 * No body, no fields. The subscription is named by the URL segment and
 * everything else the round needs — the provider, the provider's subscription
 * id, the charge list — is READ from our own records and from the gateway.
 * There is deliberately nothing for the caller to supply: a staff console that
 * could pass its own provider or charge list would be a second, unaudited way
 * to move money-bearing state, which is precisely what the platform-revenue
 * refactor exists to make impossible (see SubscriptionReconciliationService's
 * class docblock, "THE ONE ARCHITECTURAL RULE").
 *
 * It exists so the frontend composable can satisfy the canonical
 * `inputContract` option (same precedent as Subscriptions_AdminSweepRunInput
 * and Subscriptions_EventReprocessInput), not because there is anything to
 * validate.
 */
import { registerContract } from './validate'

export interface Subscriptions_SubscriptionSyncInput {}

registerContract('Subscriptions_SubscriptionSyncInput', {})
